import React from 'react';
import { AdminHeader, AdminSidebar } from 'components';
import { HrManagerForm } from 'components/organisms/HrManagerForm';

export const HrManagerSettings = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <HrManagerForm />
      </div>
    </>
  );
};
